import { createSvgIcon } from '@mui/material';

const MIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.252"
    height="20.347"
    viewBox="0 0 21.252 20.347"
  >
    <g id="Group_3004" data-name="Group 3004" transform="translate(-1079.456 -513.555)">
      <path
        id="Path_2818"
        data-name="Path 2818"
        d="M1080.422,529.716V517.949l9.788-3.645,9.528,3.645v11.61l-9.58,3.592Z"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        id="Path_2819"
        data-name="Path 2819"
        d="M1097.517,525.2l-4.359,1.623v5.206l-4.373-1.562v-5.345l4.432-1.65Z"
        transform="translate(-5.689 -6.241)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        id="Path_2820"
        data-name="Path 2820"
        d="M1080.422,525.708l9.771,3.679,9.545-3.679"
        transform="translate(0 -7.758)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        id="Line_719"
        data-name="Line 719"
        y1="11.524"
        transform="translate(1090.158 521.594)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        id="Line_720"
        data-name="Line 720"
        x1="4.2"
        y2="1.597"
        transform="translate(1093.393 527.554)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        id="Line_721"
        data-name="Line 721"
        x1="3.506"
        y2="1.296"
        transform="translate(1094.087 525.615)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
  </svg>,
  'MIcon',
);

export default MIcon;
